import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _slicedToArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["position", "isCOTD", "isMobile", "banners", "containerProps"];
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useCallback, useContext } from "react";
import { AppExperimentContext, SOURCE_TYPE_SEARCH_TOP_SPONSORED_BANNER } from "@catchoftheday/analytics";
import { RETAIL_MEDIA_PRODUCT_INVENTORY_ID, RETAIL_MEDIA_SEARCH_INVENTORY_ID, RetailMediaBanner } from "@catchoftheday/seller";
import { PageBannerDocument, usePageBannerQuery } from "../../../generated/graphql.jsx";
import { BannerPlaceholder } from "../../pure/Banners/BannerPlaceholder/BannerPlaceholder.jsx";
import { ScheduledBanner } from "../../pure/Banners/ScheduledBanner/ScheduledBanner.jsx";
import { getRetailMediaExperiment } from "./utils.js";
import { jsx as ___EmotionJSX } from "@emotion/react";

var commonLayoutProps = function commonLayoutProps(props) {
  return _objectSpread({
    pr: {
      _: 2,
      md: 0
    }
  }, props);
};

export var BannerContainer = function BannerContainer(_ref) {
  var _data$bannerByPage;

  var position = _ref.position,
      isCOTD = _ref.isCOTD,
      isMobile = _ref.isMobile,
      _banners = _ref.banners,
      containerProps = _ref.containerProps,
      bannerProps = _objectWithoutProperties(_ref, _excluded);

  var pageType = bannerProps.pageType;

  var _useContext = useContext(AppExperimentContext),
      getExperiments = _useContext.getExperiments;

  var _getExperiments = getExperiments([getRetailMediaExperiment(pageType, position)]),
      _getExperiments$exper = _slicedToArray(_getExperiments.experiments, 1),
      retailMediaExperiment = _getExperiments$exper[0],
      experimentsLoading = _getExperiments.loading;

  var shouldDisplayRetailMediaBanner = (retailMediaExperiment === null || retailMediaExperiment === void 0 ? void 0 : retailMediaExperiment.bucket) === 1 && isCOTD;

  var _usePageBannerQuery = usePageBannerQuery({
    variables: {
      input: {
        page: pageType
      }
    },
    skip: !!_banners
  }),
      data = _usePageBannerQuery.data,
      scheduledBannersLoading = _usePageBannerQuery.loading;

  var banners = _banners || (data === null || data === void 0 ? void 0 : (_data$bannerByPage = data.bannerByPage) === null || _data$bannerByPage === void 0 ? void 0 : _data$bannerByPage.banners);
  var getBanners = useCallback(function (platform) {
    return (banners || []).filter(function (_ref2) {
      var platforms = _ref2.platforms;
      return platforms.includes(platform);
    });
  }, [banners]);
  if (scheduledBannersLoading || experimentsLoading) return ___EmotionJSX(BannerPlaceholder, commonLayoutProps(containerProps)); // #region Retail media banner

  if (shouldDisplayRetailMediaBanner && (!(banners !== null && banners !== void 0 && banners.length) || position === "bottom")) {
    return ___EmotionJSX(RetailMediaBanner, _extends({
      isMobile: !!isMobile,
      px: 0
    }, commonLayoutProps(containerProps), bannerProps.pageType === "SEARCH" ? {
      inventoryId: RETAIL_MEDIA_SEARCH_INVENTORY_ID,
      searchQuery: bannerProps.searchQuery,
      sourceId: bannerProps.searchQuery,
      sourceType: SOURCE_TYPE_SEARCH_TOP_SPONSORED_BANNER,
      pageId: bannerProps.pageType.toLowerCase()
    } : {
      inventoryId: RETAIL_MEDIA_PRODUCT_INVENTORY_ID,
      sourceId: RETAIL_MEDIA_PRODUCT_INVENTORY_ID,
      sourceType: SOURCE_TYPE_SEARCH_TOP_SPONSORED_BANNER,
      offerId: bannerProps.offerId,
      category: bannerProps.category,
      pageId: bannerProps.pageType.toLowerCase()
    }));
  } // #endregion
  // Only retail media banners are supported for bottom position


  if (position === "bottom") return null; // #region Scheduled top banners

  if (isMobile) {
    return ___EmotionJSX(React.Fragment, null, getBanners("MOBILE").map(function (banner, idx) {
      return ___EmotionJSX(ScheduledBanner, _extends({
        key: banner.id,
        sourcePosition: idx + 1
      }, banner, commonLayoutProps(containerProps)));
    }));
  }

  return ___EmotionJSX(React.Fragment, null, getBanners("DESKTOP").map(function (banner, idx) {
    return ___EmotionJSX(ScheduledBanner, _extends({
      key: banner.id,
      sourcePosition: idx + 1
    }, banner, commonLayoutProps(containerProps)));
  })); // #endregion
};
export var bannerContainerGetServerSideProps = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(client) {
    var scheduledBannerData;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            scheduledBannerData = /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return client.query({
                          query: PageBannerDocument,
                          variables: {
                            input: {
                              page: "PRODUCT"
                            }
                          }
                        });

                      case 3:
                        return _context.abrupt("return", _context.sent);

                      case 6:
                        _context.prev = 6;
                        _context.t0 = _context["catch"](0);
                        console.error("Error occurred while getting scheduled banners", _context.t0);
                        return _context.abrupt("return");

                      case 10:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[0, 6]]);
              }));

              return function scheduledBannerData() {
                return _ref4.apply(this, arguments);
              };
            }();

            _context2.next = 3;
            return scheduledBannerData();

          case 3:
            _context2.t0 = _context2.sent;
            return _context2.abrupt("return", {
              scheduledBanners: _context2.t0
            });

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function bannerContainerGetServerSideProps(_x) {
    return _ref3.apply(this, arguments);
  };
}();